import { Camera, ImageIcon } from 'lucide-react'
import useInView from '../../hooks/useInView'

const PLACEHOLDERS = [
  { label: 'Mukokoroshi Platter', category: 'Kitchen' },
  { label: 'Steak & Stew Vors', category: 'Kitchen' },
  { label: 'Mala A Khuhu', category: 'Kitchen' },
  { label: 'Khwandadza Special', category: 'Kitchen' },
  { label: 'Mashonzha Plate', category: 'Kitchen' },
  { label: 'Chicken Liver Plate', category: 'Kitchen' },
  { label: 'Fresh Bread Selection', category: 'Bakery' },
  { label: 'Scones & Fatcook', category: 'Bakery' },
  { label: 'Dagwood Sandwich', category: 'Bakery' },
  { label: 'Russian Kota', category: 'Bakery' },
  { label: 'School Buns Pack', category: 'Bakery' },
  { label: 'Hotdog Rolls', category: 'Bakery' },
]

function ScrollReveal({ children, delay = 0, className = '' }) {
  const [ref, inView] = useInView()
  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)',
        transition: `opacity 0.7s ease-out ${delay}s, transform 0.7s ease-out ${delay}s`,
      }}
    >
      {children}
    </div>
  )
}

export default function Gallery() {
  return (
    <div>
      {/* Page header */}
      <section className="bg-charcoal relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, #E8761A, transparent)' }} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-20 sm:py-28">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-6 h-0.5 bg-terracotta" />
            <span className="font-body text-[11px] font-semibold tracking-[0.25em] uppercase text-terracotta">Photos</span>
          </div>
          <h1 className="font-display text-cream tracking-[0.04em] leading-[0.95]" style={{ fontSize: 'clamp(48px, 6vw, 88px)' }}>
            Gallery
          </h1>
          <p className="text-sm text-muted mt-4 max-w-xl">
            A taste of what we serve at Desres Kitchen and Yahweh's Delight.
          </p>
        </div>
      </section>

      <div className="h-px" style={{ background: 'linear-gradient(90deg, transparent, #E8761A, transparent)' }} />

      {/* Gallery grid */}
      <section className="bg-umber">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-20 sm:py-28">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {PLACEHOLDERS.map((item, i) => (
              <ScrollReveal key={i} delay={0.1 + i * 0.05}>
                <div className="group relative aspect-square bg-surface border border-border-dark rounded-2xl overflow-hidden hover:border-terracotta/40 transition-colors">
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-muted group-hover:text-ink-mid transition-colors">
                    <ImageIcon size={32} className="mb-2" />
                    <span className="text-xs font-body text-center px-2">{item.label}</span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-cream/60 to-transparent p-3">
                    <span className={`text-[10px] font-body font-semibold tracking-[0.15em] uppercase px-2 py-0.5 rounded-full ${
                      item.category === 'Kitchen'
                        ? 'bg-terracotta text-white'
                        : 'bg-ochre text-cream'
                    }`}>
                      {item.category}
                    </span>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal delay={0.3}>
            <div className="mt-16 text-center">
              <div className="inline-flex items-center gap-3 bg-surface border border-border-dark rounded-2xl shadow-[0_2px_12px_rgba(0,0,0,0.07)] px-8 py-5">
                <Camera size={20} className="text-ink-mid" />
                <p className="text-sm text-muted">
                  Photos coming soon! Follow us on social media for the latest.
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  )
}
